import { NodeDetails, RelationDetails, AbstractNodeDetails, AbstractRelationDetails } from './renderers'
import {
  NODE
  RELATION
  RELATION_VIEW
  ATTRIBUTES
  VIEWTYPE
} from 'Types'

export configureItemRenderer = (type, viewType) ->
  if type in [NODE, ATTRIBUTES] and viewType isnt VIEWTYPE.ABSTRACT
    NodeDetails
  else if type is RELATION and viewType isnt VIEWTYPE.ABSTRACT
    RelationDetails
  else if type in [NODE, ATTRIBUTES] and viewType is VIEWTYPE.ABSTRACT
    AbstractNodeDetails
  else if type is RELATION and viewType is VIEWTYPE.ABSTRACT
    AbstractRelationDetails
  else
    -> <div />